import React, { BaseSyntheticEvent } from 'react';
import {
  TTableBody,
  TTableRow
} from '../../../shared_components/vrr_table/types';
import { TCampaignVideo } from '../types';
import { TCampaignRow } from './types';
import { Input } from 'reactstrap';

export const FILTERS = [
  {
    id: 'all',
    label: 'import_data.import_data_modal.2.filters.all',
    isActive: true
  },
  {
    id: 'campaign',
    label: 'import_data.import_data_modal.2.filters.campaigns',
    isActive: false
  },
  {
    id: 'video',
    label: 'import_data.import_data_modal.2.filters.videos',
    isActive: false
  }
];

const getLine = (
  line: TCampaignRow[],
  onChangeAction?: (value: string, isChecked: boolean) => void
): TTableRow['cellElements'] => {
  const newLine: TTableRow['cellElements'] = [];
  newLine.push({
    headerId: 'checkbox',
    id: line[0].rowId,
    component: (
      <Input
        id={`campaign-table-${line[0].rowId}`}
        type="checkbox"
        className="campaign-table-input"
        onClick={(e: BaseSyntheticEvent) => {
          if (onChangeAction) onChangeAction(line[0].value, e.target.checked);
        }}
      />
    ),
    value: ''
  });
  line?.forEach((cell) => {
    newLine.push({
      headerId: cell.headerId,
      id: cell.rowId,
      component:
        cell.headerId === 'type' ? (
          <i
            className={`tim-icons ${cell.value === 'video' ? 'icon-video-66' : 'icon-chart-bar-32'}`}
          />
        ) : (
          <div>{cell.value}</div>
        ),
      value: cell.value
    });
  });
  return newLine;
};

export const prepareLine = (
  campaign: TCampaignVideo,
  index: string
): TCampaignRow[] => {
  const newLine: TCampaignRow[] = [];
  Object.keys(campaign)?.forEach((key) => {
    if (key === 'type' || key === 'name') {
      newLine.push({
        headerId: key,
        rowId: index,
        value:
          key === 'type' || campaign.type === 'campaign'
            ? campaign[key as keyof TCampaignVideo] ?? ''
            : `${campaign.name} - ${campaign.time}` ?? ''
      });
    }
  });
  return newLine;
};

export const prepareBody = (
  campaigns?: TCampaignVideo[],
  onChangeAction?: (value: string, isChecked: boolean) => void
): TTableBody['rowElements'] => {
  const newBody: TTableBody['rowElements'] = [];
  campaigns?.forEach((campaign, index) => {
    const line = prepareLine(campaign, index.toString());
    newBody.push(getLine(line, onChangeAction));
  });

  return newBody;
};

export const getTotalByFilter = (
  filterId: string,
  campaigns?: TCampaignVideo[]
) => {
  if (filterId === 'all') return campaigns?.length;
  return campaigns?.filter((campaign) => campaign.type === filterId).length;
};
